<template>
    <div>
        <h2 class="mb-4">
            {{ $t('gpdr.cookieDisclaimer.settingsPage.title') }}
        </h2>
        <span v-html="$t('gpdr.cookieDisclaimer.settingsPage.body')"/>

        <v-container
            fluid
            class="py-6"
        >
            <v-row align="start">
                <v-col
                    cols="12"
                    sm="5"
                    md="4"
                    lg="2"
                >
                    <DisclaimerButton
                        :gtmId="$vuetify.breakpoint.xsOnly ? 'gtm-gpdr-cta-accept-policies' : 'gtm-gpdr-cta-reject-policies'"
                        :key="$vuetify.breakpoint.xsOnly ? 'acceptPoliciesButton'  : 'rejectPoliciesButton'"
                        :text="$vuetify.breakpoint.xsOnly ? $t('gpdr.cookieDisclaimer.cta.acceptAll') : $t('gpdr.cookieDisclaimer.cta.rejectAll')"
                        :isOutlined="false"
                        :backgroundColor="$vuetify.breakpoint.xsOnly ? '#388E3C' : null"
                        :textColor="$vuetify.breakpoint.xsOnly ? '#FFFFFF' : null"
                        @click-action="$vuetify.breakpoint.xsOnly ? acceptPolicies() : rejectPolicies()"
                    />
                </v-col>
                <v-col
                    cols="12"
                    sm="3"
                    md="4"
                    lg="2"
                >
                    <DisclaimerButton
                        :gtmId="$vuetify.breakpoint.xsOnly ? 'gtm-gpdr-cta-reject-policies' : 'gtm-gpdr-cta-accept-policies'"
                        :key="$vuetify.breakpoint.xsOnly ? 'rejectPoliciesButton' : 'acceptPoliciesButton'"
                        :text="$vuetify.breakpoint.xsOnly ? $t('gpdr.cookieDisclaimer.cta.rejectAll') : $t('gpdr.cookieDisclaimer.cta.acceptAll')"
                        :isOutlined="false"
                        :backgroundColor="$vuetify.breakpoint.xsOnly ? null : '#388E3C'"
                        :textColor="$vuetify.breakpoint.xsOnly ? null : '#FFFFFF'"
                        @click-action="$vuetify.breakpoint.xsOnly ? rejectPolicies() : acceptPolicies()"
                    />
                </v-col>
            </v-row>
        </v-container>

        <v-divider/>

        <div class="my-4 text-subtitle-1 font-weight-bold">
            {{ $t('gpdr.cookieDisclaimer.settingsPage.subtitle1') }}
        </div>
        <span v-html="$t('gpdr.cookieDisclaimer.settingsPage.body1')"/>

        <div class="my-4 text-subtitle-1 font-weight-bold">
            {{ $t('gpdr.cookieDisclaimer.settingsPage.subtitle2') }}
        </div>
        <span v-html="$t('gpdr.cookieDisclaimer.settingsPage.body2')"/>

        <TrackerSwitch
            key="googleTracker"
            :label="$t('gpdr.cookieDisclaimer.settingsPage.googleTracker')"
            :provider="'google'"
            :status="isTrackingEnabled['google'] ? isTrackingEnabled['google'] : false"
            @set-tracker-userchoice="updateTracker"
        />


        <DisclaimerButton
            gtmId="gtm-gpdr-cta-save-settings"
            key="saveUserSettingsButton"
            :text="$t('gpdr.cookieDisclaimer.cta.save')"
            :thickBorder="true"
            @click-action="saveUserchoice"
        />
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    import DisclaimerButton from '@/components/gdpr/components/DisclaimerButton';
    import TrackerSwitch from '@/components/gdpr/components/TrackerSwitch';

    export default {
        name: 'SettingsPage',
        data() {
            return {
                trackingEnabled: {}
            }
        },
        computed: {
            ...mapGetters([
                'availableTrackings',
                'isLocalstorageAvailable',
            ]),
            isTrackingEnabled: {
                get() {
                    return this.trackingEnabled;
                },
                set(provider, status) {
                    this.trackingEnabled[provider] = status;
                }
            },
            promoterUuid() {
                return this.$route.query.key;
            },
            trackersKey() {
                return `trackers-${this.promoterUuid}`;
            },
            trackersSettings() {
                return this.isLocalstorageAvailable ? (localStorage.getItem(this.trackersKey) ? JSON.parse(localStorage.getItem(this.trackersKey)) : {}) : null;
            }
        },
        components: {
            DisclaimerButton,
            TrackerSwitch
        },
        mounted() {
            this.isTrackingEnabled['google'] = 'google' in this.trackersSettings ? this.trackersSettings['google'] : false;
        },
        methods: {
            ...mapActions([
                'setTrackingStatus'
            ]),
            acceptPolicies() {
                this.$emit('accept-policies');
            },
            rejectPolicies() {
                this.$emit('reject-policies');
            },
            updateTracker(provider, status) {
                this.trackingEnabled[provider] = status;
            },
            saveUserchoice() {
                this.setTrackingStatus({
                    'provider': 'google',
                    'status': this.trackingEnabled['google']
                });
                this.$emit('save-custom-settings');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/gdpr/pages/SettingsPage.vue